// Base URL Configuration
const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.bhojpurivideos.com/api';
// const BASE_URL = process.env.REACT_APP_API_URL || 'http://192.168.168.68:5000/api';

// Backend server URL (for static files like uploaded images)
export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'https://api.bhojpurivideos.com';
// export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://192.168.168.68:5000';

export default BASE_URL;
    